/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBillFile } from './APIBillFile';
import {
    APIBillFileFromJSON,
    APIBillFileFromJSONTyped,
    APIBillFileToJSON,
} from './APIBillFile';

/**
 * 
 * @export
 * @interface APIPaginatedBillFileList
 */
export interface APIPaginatedBillFileList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedBillFileList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBillFileList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBillFileList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIBillFile>}
     * @memberof APIPaginatedBillFileList
     */
    results: Array<APIBillFile>;
}

/**
 * Check if a given object implements the APIPaginatedBillFileList interface.
 */
export function instanceOfAPIPaginatedBillFileList(value: object): value is APIPaginatedBillFileList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedBillFileListFromJSON(json: any): APIPaginatedBillFileList {
    return APIPaginatedBillFileListFromJSONTyped(json, false);
}

export function APIPaginatedBillFileListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedBillFileList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIBillFileFromJSON)),
    };
}

export function APIPaginatedBillFileListToJSON(value?: APIPaginatedBillFileList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIBillFileToJSON)),
    };
}

